import React from 'react';
import { useDispatch } from 'react-redux';
import ReduxDrawer from 'containers/DrawerManager/ReduxDrawer';
import { closeEditBillingDrawer } from '../actions';
import BillingInformationForm from './form';
import { EDIT_BILLING_INFORMATION } from './constants';

const EditBillingInformationDrawer = () => {
  const dispatch = useDispatch();
  const handleHideForm = () => dispatch(closeEditBillingDrawer());

  return (
    <ReduxDrawer
      WrappedComponent={BillingInformationForm}
      drawerKey={EDIT_BILLING_INFORMATION}
      drawerProps={{
        headerTitle: 'Payment Methods',
      }}
      props={{
        onClose: handleHideForm,
      }}
    />
  );
};

export default EditBillingInformationDrawer;
